import React from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';
import { useTranslation } from '~/behaviors/languages';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';
import UnknownErrorImage from '~/assets/images/unknownerror.png';

const useStyles = jss.makeStyles((theme) => ({
  subtitle: {
    // @ts-ignore it does exist, but we would need to declare it to TS
    color: theme.palette.gray2,
    lineHeight: 1.2,
  },
  button: {
    textTransform: 'uppercase',
  },
}));

export type CustomErrorBoundaryProps = Omit<ErrorBoundaryProps, 'fallbackRender'>;

function Fallback({ error, resetErrorBoundary }) {
  const classes = useStyles();
  const { t } = useTranslation();
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <mui.Grid container justifyContent="center" alignContent="center" height="100%" width="100%" role="alert">
      <mui.Grid item container maxWidth={500} direction="column" textAlign="center">
        <mui.Grid item marginBottom={4}>
          <img src={UnknownErrorImage} alt={t('errorBoundary.headImageAltText')} />
        </mui.Grid>
        <mui.Grid item>
          <mui.Typography variant="h3">{t('errorBoundary.title')}</mui.Typography>
        </mui.Grid>
        <mui.Grid item marginTop={0.5}>
          <mui.Typography variant="h4" className={classes.subtitle}>
            {t('errorBoundary.subtitle')}
          </mui.Typography>
        </mui.Grid>
        <mui.Grid item marginTop={2}>
          <mui.Typography variant="body2">{t('errorBoundary.errorPreDescription')}</mui.Typography>
          <mui.Typography variant="body2">{error.message}</mui.Typography>
        </mui.Grid>
        <mui.Grid item marginTop={3}>
          <mui.Button onClick={resetErrorBoundary} variant="contained" className={classes.button}>
            {t('errorBoundary.resetButton')}
          </mui.Button>
        </mui.Grid>
      </mui.Grid>
    </mui.Grid>
  );
}

export const CustomErrorBoundary = (props: CustomErrorBoundaryProps) => {
  const { children, onReset } = props;

  return (
    <ErrorBoundary onReset={onReset} FallbackComponent={Fallback}>
      <>{children}</>
    </ErrorBoundary>
  );
};
